import { render, staticRenderFns } from "./EditionBlock.vue?vue&type=template&id=0f26aadc&scoped=true&"
import script from "./EditionBlock.vue?vue&type=script&lang=js&"
export * from "./EditionBlock.vue?vue&type=script&lang=js&"
import style0 from "./EditionBlock.vue?vue&type=style&index=0&id=0f26aadc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f26aadc",
  null
  
)

export default component.exports